import api from './api';

/**
 * Servicio para gestionar auditoría
 */
export const auditoriaService = {
  /**
   * Obtener todos los logs de auditoría
   * @param {number} usuarioId - ID del usuario para filtrar (opcional)
   * @param {number} empresaId - ID de la empresa para filtrar (opcional)
   * @param {number} sucursalId - ID de la sucursal para filtrar (opcional)
   * @param {string} modulo - Módulo para filtrar (opcional)
   * @param {string} tipoAccion - Tipo de acción para filtrar (opcional)
   * @param {string} fechaDesde - Fecha desde (opcional)
   * @param {string} fechaHasta - Fecha hasta (opcional)
   */
  getAll: async (usuarioId = null, empresaId = null, sucursalId = null, modulo = null, tipoAccion = null, fechaDesde = null, fechaHasta = null) => {
    const params = {};
    if (usuarioId) params.usuarioId = usuarioId;
    if (empresaId) params.empresaId = empresaId;
    if (sucursalId) params.sucursalId = sucursalId;
    if (modulo) params.modulo = modulo;
    if (tipoAccion) params.tipoAccion = tipoAccion;
    if (fechaDesde) params.fechaDesde = fechaDesde;
    if (fechaHasta) params.fechaHasta = fechaHasta;
    const response = await api.get('/auditoria', { params });
    return response;
  },

  /**
   * Obtener logs de auditoría por usuario
   * @param {number} usuarioId - ID del usuario
   * @param {string} fechaDesde - Fecha desde (opcional)
   * @param {string} fechaHasta - Fecha hasta (opcional)
   */
  getByUsuario: async (usuarioId, fechaDesde = null, fechaHasta = null) => {
    const params = {};
    if (fechaDesde) params.fechaDesde = fechaDesde;
    if (fechaHasta) params.fechaHasta = fechaHasta;
    const response = await api.get(`/auditoria/usuario/${usuarioId}`, { params });
    return response;
  },

  /**
   * Obtener logs de auditoría por módulo
   * @param {string} modulo - Nombre del módulo
   * @param {string} fechaDesde - Fecha desde (opcional)
   * @param {string} fechaHasta - Fecha hasta (opcional)
   */
  getByModulo: async (modulo, fechaDesde = null, fechaHasta = null) => {
    const params = {};
    if (fechaDesde) params.fechaDesde = fechaDesde;
    if (fechaHasta) params.fechaHasta = fechaHasta;
    const response = await api.get(`/auditoria/modulo/${modulo}`, { params });
    return response;
  },
};

